// extracted by mini-css-extract-plugin
module.exports = {"margin_left_20":"SchoolQuestion_margin_left_20__TGVxa","margin_back":"SchoolQuestion_margin_back__293bA"};